import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Planning from "@/pages/Planning";
import SKUs from "@/pages/SKUs";
import Materials from "@/pages/Materials";
import Procurement from "@/pages/Procurement";
import Batches from "@/pages/Batches";
import Machines from "@/pages/Machines";
import QC from "@/pages/QC";
import FinishedGoods from "@/pages/FinishedGoods";
import Dispatch from "@/pages/Dispatch";
import Trace from "@/pages/Trace";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Labels from "@/pages/Labels";
import Kanban from "@/pages/Kanban";
import Analytics from "@/pages/Analytics";
import Operators from "@/pages/Operators";
import Attendance from "@/pages/Attendance";
import Settings from "@/pages/Settings";
import Kitchen from "@/pages/Kitchen";
import Management from "@/pages/Management";
import AuditLog from "@/pages/AuditLog";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/kanban" element={<Kanban />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/operators" element={<Operators />} />
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/planning" element={<Planning />} />
              <Route path="/skus" element={<SKUs />} />
              <Route path="/materials" element={<Materials />} />
              <Route path="/procurement" element={<Procurement />} />
              <Route path="/batches" element={<Batches />} />
              <Route path="/machines" element={<Machines />} />
              <Route path="/kitchen" element={<Kitchen />} />
              <Route path="/management" element={<Management />} />
              <Route path="/qc" element={<QC />} />
              <Route path="/finished-goods" element={<FinishedGoods />} />
              <Route path="/dispatch" element={<Dispatch />} />
              <Route path="/trace" element={<Trace />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/users" element={<Users />} />
              <Route path="/audit" element={<AuditLog />} />
              <Route path="/labels/:batch_no" element={<Labels />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
